// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertOutlinedSvg from "@fishx/icons-svg/es/asn/AlertOutlined";
import FishxIcon from '../components/FishxIcon';

var AlertOutlined = function AlertOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlertOutlinedSvg
  }));
};

AlertOutlined.displayName = 'AlertOutlined';
export default React.forwardRef(AlertOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlertOutlined.js
// module id = 1954
// module chunks = 0